import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading, error, auth, checkAuth } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user && auth.isAuthenticated() && error) {
    return (
      <div className="loading-container">
        <p role="alert">{error}</p>
        <button type="button" onClick={() => checkAuth()}>Retry connection</button>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
}